import { coerceNumberProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignalWithTransform,
  computed,
  Signal,
} from '@angular/core';
import { clamp } from '@lyceo/shared/util';

@Component({
  selector: 'lyceo-progress-donut',
  imports: [],
  templateUrl: './progress-donut.component.html',
  styleUrls: ['./progress-donut.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressDonutComponent {
  public readonly value: InputSignalWithTransform<number, unknown> =
    input.required({
      transform: (value) => clamp(coerceNumberProperty(value), 0, 1),
    });

  public size: number = 24;
  public center: number = this.size / 2;
  public strokeWidth: number = 2;
  public radius: number = this.center - this.strokeWidth / 2;
  public dashArray: number = 2 * Math.PI * this.radius;
  public dashOffset: number = 0;

  public readonly getDashOffset: Signal<number> = computed(() => {
    return (this.dashOffset = this.dashArray * (1 - this.value()));
  });
}
